import styled from "@emotion/styled"
import Typography from "@mui/material/Typography"
import { Link } from "utils"
import { mediaQueries } from "../../theme/mediaQueries"
import { sizes } from "../../theme/sizes"
import { colors } from "../../theme/colors"

// Figma "Dark" / "Black" text token (#051711) — no theme primitive matches it.
const TEXT_DARK = "#051711"
// Figma "Grey/Gray M" card border (#d1d5db).
const CARD_BORDER = "#d1d5db"

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${sizes.spacing[24]}px;
  width: 100%;
  background: ${colors.primitives.neutral0};
  /* EGDE-378: the block sat too tight against its neighbours on mobile — give it
     the same 40px vertical rhythm the tablet/desktop layout already uses. */
  padding-block: ${sizes.spacing[40]}px;
`

export const Title = styled(Typography)`
  text-align: start;
  font-weight: 700;
  color: ${TEXT_DARK};
`

export const CardsRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${sizes.spacing[16]}px;
  width: 100%;

  ${mediaQueries.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: ${sizes.spacing[24]}px;
  }
`

export const ChannelCard = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${sizes.spacing[16]}px;
  width: 100%;
  /* EGDE-378 (QA r3): the real ask was more room INSIDE each card, not an outer
     gutter. 24px inner padding on all sides on mobile; desktop keeps its 16px. */
  padding: ${sizes.spacing[24]}px;
  background: ${colors.primitives.neutral0};
  border: 1px solid ${CARD_BORDER};
  border-radius: ${sizes.borderRadius[12]}px;
  text-decoration: none;
  cursor: pointer;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;

  ${mediaQueries.tablet} {
    width: 250px;
    height: 162px;
    padding: ${sizes.spacing[16]}px;
  }

  &:hover {
    border-color: ${CARD_BORDER};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  }
`

export const ChannelLabel = styled(Typography)`
  text-align: center;
  color: ${TEXT_DARK};
`
